export enum EventStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  IN_TRANSITION = 'IN_TRANSITION',
}
